/**
 * Узбекский набор строк.
 */

import type { Strings } from './index';

export const uz: Strings = {
  login_title: 'CargoPASS tizimiga kirish',
  login_phone_label: 'Telefon raqami',
  login_code_request: 'Kod olish',
  login_code_label: 'Xabardagi kod',
  login_code_submit: 'Kirish',
  login_failed: 'Kirib bo‘lmadi. Qaytadan urinib ko‘ring.',
  works_title: 'Ishlar',
  works_more: 'Yana ko‘rsatish',
  works_failed: 'Ro‘yxatni yuklab bo‘lmadi.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'Telefon orqali',
  login_channel_email: 'E-pochta orqali',
  login_email_label: 'E-pochta manzili',
  login_terms_label: 'Foydalanish shartlariga roziman',
  company_switcher_label: 'Firma',
  language_label: 'Til',
  state_loading: 'Yuklanmoqda…',
  state_empty: 'Hozircha hech narsa yo‘q',
  state_error: 'Ma’lumotni olib bo‘lmadi',
  state_no_access: 'Bu sahifa sizga ochiq emas',
  no_membership_title: 'Siz hech bir firmada emassiz',
  no_membership_explain: 'Ishlash uchun firmaga qo‘shiling yoki o‘zingiznikini oching.',
  company_create_submit: 'Firma ochish',
  company_name_label: 'Firma nomi',
  company_form_type_label: 'Firma turi',
  company_tax_id_label: 'Ro‘yxatga olish raqami',
  company_legal_address_label: 'Yuridik manzil',
  company_members_title: 'Firma xodimlari',
  not_found_title: 'Bunday sahifa yo‘q',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Mening profilim',
  profile_sessions_title: 'Faol seanslar',
  profile_session_current: 'Joriy seans',
  profile_session_never_used: 'Hech qachon ishlatilmagan',
  profile_session_terminate: 'Yakunlash',
  profile_channel_add: 'Aloqa kanalini qo‘shish',
  profile_channel_code_request: 'Kod yuborish',
  profile_channel_confirm: 'Kanalni tasdiqlash',
  members_title: 'Xodimlar',
  members_invite: 'Xodimni taklif qilish',
  invite_channel_phone: 'Telefon bilan',
  invite_channel_email: 'E-pochta bilan',
  invite_role_label: 'Rol',
  invite_submit: 'Taklifnomani yuborish',
  invitations_title: 'Taklifnomalar',
  invitation_revoke: 'Qaytarib olish',
  invitation_resend: 'Qayta yuborish',
  rights_title: 'Xodim huquqlari',
  rights_grants: 'Rol ustiga berilgan',
  rights_denies: 'Shaxsan taqiqlangan',
  rights_grant_add: 'Huquq berish',
  rights_deny_add: 'Taqiq qo‘yish',
  rights_remove: 'O‘chirish',
  company_profile_title: 'Firma profili',
  company_documents_title: 'Firma hujjatlari',
  company_type_transport: 'Tashuvchi',
  company_type_logistics: 'Logistika firmasi',
  member_documents_title: 'Xodim hujjatlari',
  document_download: 'Faylni ochish',
  enum_unknown: 'Noma’lum',
  role_director: 'Direktor',
  role_logist: 'Logist',
  role_dispatcher: 'Dispetcher',
  role_accountant: 'Buxgalter',
  role_mechanic: 'Mexanik',
  role_driver: 'Haydovchi',
  member_status_active: 'Amal qiladi',
  member_status_closed: 'Yopilgan',
  permission_company_staff_manage: 'Xodimlarni boshqarish',
  permission_company_rights_manage: 'Huquqlarni boshqarish',
  permission_company_fleet_manage: 'Avtoparkni boshqarish',
  permission_company_fleet_repair: 'Ta’mirni belgilash',
  permission_company_docs_manage: 'Hujjatlarni boshqarish',
  permission_company_listings_manage: 'E’lonlarni boshqarish',
  permission_company_cargo_take: 'Yuk olish',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Transport va haydovchi tayinlash',
  permission_company_accounting_manage: 'Firma xarajatlari va to‘lovlarini yuritish',
  document_status_pending: 'Tekshiruvda',
  document_status_verified: 'Tasdiqlangan',
  document_status_rejected: 'Rad etilgan',
  document_status_expired: 'Muddati tugagan',
  document_status_not_verified: 'Tasdiqlanmagan',
  invitation_status_pending: 'Javob kutilmoqda',
  invitation_status_accepted: 'Qabul qilindi',
  invitation_status_revoked: 'Bekor qilindi',
  invitation_status_expired: 'Muddati tugadi',

  // Ключи блока `WEB-1.3`: транспорт фирмы, цикл ремонта, сервисная история и
  // заявки на освобождение VIN.
  fleet_title: 'Firma transporti',
  fleet_add: 'Transport qo‘shish',
  fleet_vin: 'VIN raqami',
  fleet_tech_passport: 'Texpasport raqami',
  fleet_kind_label: 'Transport turi',
  fleet_body_type_label: 'Kuzov turi',
  fleet_withdraw: 'Reyestrdan chiqarish',
  fleet_withdrawn_at: 'Chiqarilgan sana',
  fleet_empty: 'Reyestr hozircha bo‘sh',
  service_title: 'Mashina servisi',
  service_state_label: 'Texnik holat',
  service_state_change: 'Holatni o‘tkazish',
  service_records_title: 'Ishlar jurnali',
  service_record_add: 'Yozuv kiritish',
  service_description: 'Nima qilindi, qaysi uzellar',
  service_parts: 'Ehtiyot qismlar',
  service_cost: 'Xarajat',
  service_currency: 'Valyuta',
  service_records_empty: 'Hozircha yozuvlar yo‘q',
  vin_claims_title: 'VIN bo‘shatish arizalari',
  vin_claim_create: 'Ariza berish',
  vin_claim_object: 'E’tiroz bildirish',
  vin_claim_window_ends_at: 'E’tiroz oynasi tugashi',
  vin_claims_empty: 'Hozircha arizalar yo‘q',
  vehicle_kind_tractor: 'Tyagach',
  vehicle_kind_trailer: 'Tirkama',
  body_type_tarpaulin: 'Tentli',
  body_type_refrigerator: 'Refrijerator',
  body_type_isothermal: 'Izotermik',
  body_type_box: 'Furgon',
  body_type_flatbed: 'Bortli',
  body_type_platform: 'Platforma',
  body_type_lowbed: 'Tral',
  body_type_mega: 'Mega-kuzov',
  body_type_car_carrier: 'Avtotashuvchi',
  body_type_tipper: 'Ag‘dargich',
  body_type_walking_floor: 'Suriluvchi pol',
  body_type_tank: 'Sisterna',
  body_type_silo: 'Silos-sisterna',
  body_type_container_chassis: 'Konteyner tashuvchi',
  body_type_bdf: 'BDF kuzovi',
  body_type_timber: 'Yog‘och tashuvchi',
  body_type_livestock: 'Mol tashuvchi',
  body_type_coil: 'Rulon tashuvchi',
  body_type_heavy_haul: 'Og‘ir yuk trali',
  body_type_extendable: 'Uzaytiriladigan',
  repair_state_fault_detected: 'Nosozlik aniqlangan',
  repair_state_in_repair: 'Ta’mirda',
  repair_state_repaired: 'Ta’mirlangan',
  repair_state_ready: 'Tayyor',
  vehicle_status_active: 'Reyestrda',
  vehicle_status_withdrawn: 'Chiqarilgan',
  vin_claim_status_pending: 'E’tiroz oynasi ochiq',
  vin_claim_status_objected: 'E’tiroz berilgan',
  vin_claim_status_awaiting_admin: 'Xodimlar qarorini kutmoqda',
  vin_claim_direction_outgoing: 'Bizning ariza',
  vin_claim_direction_incoming: 'Bizga kelgan ariza',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Peregonni kuzatish',
  tracking_pin_hint: 'Buyurtmachi havola bilan birga bergan olti xonali PIN kodni kiriting. PIN kodsiz sahifa hech narsa ko‘rsatmaydi.',
  tracking_pin_label: 'Olti xonali PIN kod',
  tracking_pin_submit: 'Ochish',
  tracking_offline: 'Aloqa yo‘q. Internetni tekshirib, qaytadan urinib ko‘ring.',
  tracking_offline_refresh: 'Aloqa yo‘q — aloqa tiklanganda yangilanadi.',
  tracking_status_changed_at: 'Holat o‘zgargan',
  tracking_vehicle: 'Mashina',
  tracking_route: 'Yo‘nalish',
  tracking_distance: 'Masofa',
  tracking_transit: 'Tranzit',
  tracking_border_crossings: 'Chegara kesishuvlari',
  tracking_last_position: 'Oxirgi nuqta',
  tracking_no_position: 'Joylashuv hali kelmadi',
  tracking_open_map: 'Xaritada ochish',
  tracking_photos: 'Mashinani qabul qilish',
  tracking_photo_open: 'Suratni ochish',
  tracking_photo_plate: 'Davlat raqami',
  tracking_photo_close: 'Yopish',
  tracking_milestones: 'Bosqichlar',
  tracking_locked_title: 'Havola vaqtincha ishlamayapti',
  tracking_retry: 'PIN kodni qayta kiritish',
  tracking_gone_title: 'Havola amal qilmaydi',
  tracking_map_title: 'Xarita: oxirgi nuqta',
  work_status_CREATED: 'Yaratildi',
  work_status_ASSIGNED: 'Tayinlandi',
  work_status_ACCEPTED: 'Ijroga qabul qilindi',
  work_status_AT_PICKUP: 'Yuklashda',
  work_status_AT_HANDOVER: 'Mashina qabuli',
  work_status_IN_TRANSIT: 'Yo‘lda',
  work_status_DELIVERED: 'Topshirildi',
  work_status_COMPLETED: 'Yakunlandi',
  work_status_CANCELLED: 'Bekor qilindi',
  work_status_ARCHIVED: 'Arxivda',
  peregon_vehicle_kind_tractor: 'Tyagach',
  peregon_vehicle_kind_tractor_with_trailer: 'Tirkamali tyagach',
  peregon_vehicle_kind_car: 'Yengil avtomobil',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  cargo_listings_title: 'Yuk e’lonlari',
  cargo_listings_create: 'E’lon berish',
  cargo_listings_more: 'Yana ko‘rsatish',
  cargo_listings_empty: 'Hozircha e’lonlar yo‘q',
  cargo_listing_edit: 'Tahrirlash',
  cargo_listing_close: 'Yopish',
  cargo_listing_close_confirm: 'E’lon yopilsinmi? Yopilgan e’lon lentaga qaytmaydi.',
  cargo_listing_km: 'km',
  cargo_listing_kg: 'kg',
  cargo_listing_days: 'kun',
  cargo_listing_transit: 'Tranzit',
  cargo_listing_borders: 'Chegaradan o‘tishlar',
  cargo_listing_slots_free: 'Bo‘sh',
  cargo_listing_slots_of: 'ta, jami',
  cargo_listing_fixed: 'Narx qat’iy',
  cargo_listing_payment: 'To‘lov',
  cargo_listing_form_title_new: 'Yangi yuk e’loni',
  cargo_listing_form_title_edit: 'Yuk e’lonini tahrirlash',
  cargo_listing_form_origin: 'Yuklash shahri',
  cargo_listing_form_destination: 'Tushirish shahri',
  cargo_listing_form_city_search: 'Shahar nomini yoza boshlang',
  cargo_listing_form_loading_at: 'Yuklash sanasi',
  cargo_listing_form_unload_by: 'Tushirish muddati',
  cargo_listing_form_vehicles_count: 'Nechta mashina kerak',
  cargo_listing_form_cargo_type: 'Yuk',
  cargo_listing_form_weight: 'Bir mashinaga og‘irlik, kg',
  cargo_listing_form_adr: 'Xavfli yuk (ADR)',
  cargo_listing_form_body_type: 'Kuzov turi',
  cargo_listing_form_body_subtype: 'Kuzovning kichik turi',
  cargo_listing_form_temperature_from: 'dan',
  cargo_listing_form_temperature_to: 'gacha',
  cargo_listing_form_price: 'Bir mashina narxi',
  cargo_listing_form_currency: 'Valyuta',
  cargo_listing_form_negotiable: 'Kelishsa bo‘ladi',
  cargo_listing_form_payment_method: 'To‘lov usuli',
  cargo_listing_form_payment_moment: 'To‘lov vaqti',
  cargo_listing_form_deferral_days: 'Kechiktirish kunlari',
  cargo_listing_form_comment: 'Izoh',
  cargo_listing_form_submit: 'E’lonni joylash',
  cargo_listing_form_save: 'O‘zgarishlarni saqlash',
  cargo_offers_title: 'Tashuvchilar takliflari',
  cargo_offer_accept: 'Ma’qullash',
  cargo_offer_decline: 'Rad etish',
  cargo_offer_decline_confirm: 'Taklif rad etilsinmi? Tashuvchi rad javobini ko‘radi.',
  cargo_offer_agrees: 'Shartlaringizga rozi',
  cargo_offer_counter: 'O‘z narxini taklif qilmoqda',
  cargo_offer_documents_verified: 'Hujjatlari tekshirilgan',
  cargo_offer_vehicles: 'Mashinalar',
  cargo_offer_price: 'Tashuvchi narxi',
  cargo_offer_listing_price: 'E’londagi narx',
  cargo_offer_expires: 'Javob muddati',
  cargo_offer_more: 'Yana takliflar',
  cargo_slots_title: 'Buyurtma taxtasi',
  cargo_slot_work: 'Ish',
  listing_status_OPEN: 'Ochiq',
  listing_status_TAKEN: 'Barcha mashinalar topildi',
  listing_status_CLOSED: 'Yopilgan',
  listing_status_CANCELLED: 'Bekor qilingan',
  listing_status_PENDING_REVIEW: 'Tekshiruvda',
  listing_status_REJECTED: 'Rad etilgan',
  cargo_offer_status_PENDING: 'Qaror kutilmoqda',
  cargo_offer_status_APPROVED: 'Ma’qullangan — tashuvchi tasdig‘i kutilmoqda',
  cargo_offer_status_CONFIRMED: 'Tashuvchi tasdiqlagan',
  cargo_offer_status_REJECTED: 'Rad etilgan',
  cargo_offer_status_WITHDRAWN: 'Tashuvchi qaytarib olgan',
  cargo_offer_status_EXPIRED: 'Muddati o‘tgan',
  cargo_offer_status_SUPERSEDED: 'Bo‘sh mashina qolmadi',
  cargo_slot_status_OPEN: 'Bo‘sh',
  cargo_slot_status_RESERVED: 'Tashuvchi tasdig‘i kutilmoqda',
  cargo_slot_status_TAKEN: 'Band',
  cargo_slot_status_CANCELLED: 'Bekor qilingan',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (so‘m)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Naqd pul',
  payment_method_bank_transfer: 'Hisob raqamiga o‘tkazma',
  payment_moment_prepayment: 'Oldindan to‘lov',
  payment_moment_on_unloading: 'Tushirishda',
  payment_moment_deferred: 'Kechiktirib',
  loading_type_rear: 'Orqadan',
  loading_type_side: 'Yon tomondan',
  loading_type_top: 'Yuqoridan',
  loading_type_full_uncover: 'To‘liq ochib',
  body_parameter_length_m: 'Uzunligi, m',
  body_parameter_width_m: 'Kengligi, m',
  body_parameter_height_m: 'Balandligi, m',
  body_parameter_volume_m3: 'Hajmi, m³',
  body_parameter_capacity_t: 'Yuk ko‘tarishi, t',
  body_parameter_loading_type: 'Yuklash usuli',
  body_parameter_temperature: 'Harorat, °C',
  body_parameter_cars_capacity: 'Sig‘imi, avtomobil',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  vehicle_card_title: 'Mashina kartochkasi',
  vehicle_photo_title: 'Mashina suratlari',
  vehicle_photo_file: 'Suratni tanlang',
  vehicle_photo_add: 'Surat qo‘shish',
  vehicle_photo_delete: 'O‘chirish',
  vehicle_photo_delete_confirm: 'Mashinaning bu suratini o‘chirasizmi?',
  vehicle_photo_empty: 'Hozircha suratlar yo‘q',
  vehicle_fault_title: 'Ochiq nosozliklar',
  vehicle_fault_empty: 'Ochiq nosozliklar yo‘q',
  vehicle_fault_author_unknown: 'Muallif ko‘rsatilmagan',
  vehicle_fault_comment: 'Mashinada nima nosoz',
  vehicle_fault_photos: 'Nosozlik suratlari',
  vehicle_fault_add: 'Nosozlikni yozish',
  vehicle_fault_history: 'Barcha nosozliklar',
  vehicle_fault_open: 'Ochiq',
  vehicle_fault_closed: 'Yopilgan',
  vehicle_fault_history_empty: 'Mashinada nosozliklar bo‘lmagan',
  drivers_title: 'Firma haydovchilari',
  drivers_age: 'Yoshi:',
  drivers_name_unknown: 'Ismi ko‘rsatilmagan',
  drivers_not_specified: 'ko‘rsatilmagan',
  drivers_self_reported: 'Ism, yosh va jinsni insonning o‘zi ko‘rsatgan',
  drivers_documents: 'Hujjatlar',
  drivers_empty: 'Hozircha haydovchilar yo‘q',
  service_part_add: 'Qator qo‘shish',
  service_part_remove: 'Olib tashlash',
  service_part_name: 'Ehtiyot qism nomi',
  service_part_quantity: 'Soni',
  vin_claim_file_label: 'Texpasport fayli — surat yoki PDF',
  vin_claim_file_link: 'Texpasport',
  vin_claim_file_missing: 'Faylsiz berilgan',
  profile_birth_date: 'Tug‘ilgan sana',
  profile_gender: 'Jinsi',
  profile_gender_unspecified: 'Ko‘rsatilmagan',
  profile_personal_note: 'Insonning o‘zi ko‘rsatgan',
  profile_personal_hint: 'Sizga ko‘rinadi; firma a’zolariga — faqat yosh va jins',
  profile_personal_save: 'Saqlash',
  gender_male: 'Erkak',
  gender_female: 'Ayol',
  document_type_passport: 'Pasport',
  document_type_driver_license: 'Haydovchilik guvohnomasi',
  document_type_adr_certificate: 'ADR guvohnomasi',
  document_type_professional_certificate: 'Kasbiy guvohnoma',
  document_type_face_snapshot: 'Yuz surati',
  document_type_tachograph_card: 'Taxograf kartasi',
  document_type_code95_card: '«Kod 95» kartasi',
  document_type_visa: 'Viza',
  document_type_registration_certificate: 'Ro‘yxatdan o‘tganlik guvohnomasi',
  expenses_title: 'Xarajatlar',
  expenses_create: 'Xarajatni yozish',
  expenses_delete_confirm: 'Bu xarajatni o‘chirasizmi?',
  expenses_empty: 'Hozircha xarajatlar yo‘q',
  expense_form_submit: 'Xarajatni saqlash',
  expense_form_category: 'Turkum',
  expense_form_spent_on: 'Xarajat sanasi',
  expense_form_vehicle: 'Mashina',
  expense_form_receipt: 'Chek — surat yoki PDF',
  expense_receipt_refreshed: 'Chek havolasi yangilandi — qaytadan oching',
  expense_receipt_replace_hint: 'yangi fayl avvalgisining o‘rnini oladi',
  payouts_title: 'To‘lovlar',
  payouts_create: 'To‘lovni yozish',
  payouts_delete_confirm: 'Bu to‘lovni o‘chirasizmi?',
  payouts_empty: 'Hozircha to‘lovlar yo‘q',
  payout_form_submit: 'To‘lovni saqlash',
  payout_form_recipient: 'Oluvchi',
  payout_form_paid_on: 'To‘lov sanasi',
  payout_recipient_unnamed: 'Ismi ko‘rsatilmagan',
  payout_recipient_not_listed: 'Firma haydovchilari ro‘yxatida yo‘q',
  payout_recipient_unavailable: 'Oluvchining ismi mavjud emas',
  payout_recipient_loading: 'Oluvchi yuklanmoqda…',
  accounting_edit: 'O‘zgartirish',
  accounting_delete: 'O‘chirish',
  accounting_more: 'Yana ko‘rsatish',
  accounting_works_more: 'Yana ishlarni ko‘rsatish',
  accounting_filter_reset: 'Tozalash',
  accounting_filter_empty: 'Bu saralash bo‘yicha yozuvlar yo‘q',
  accounting_filter_any: 'Barchasi',
  accounting_work_fallback: 'Ish',
  accounting_vehicle_fallback: 'Mashina',
  accounting_vehicle_missing: 'Mashina reyestrda topilmadi',
  accounting_no_vehicle: 'Mashinasiz',
  accounting_no_work: 'Ishga bog‘lanmagan',
  accounting_field_amount: 'Summa',
  accounting_field_currency: 'Valyuta',
  accounting_field_work: 'Ish',
  accounting_field_comment: 'Izoh',
  accounting_choose: 'Tanlang',
  accounting_form_close: 'Bekor qilish',
  expense_category_diesel: 'Dizel yoqilg‘isi',
  expense_category_parking: 'To‘xtash joyi',
  expense_category_toll: 'Pullik yo‘l',
  expense_category_service: 'Texnik xizmat va ta’mir',
  expense_category_other: 'Boshqa',
};
